module.exports = __webpack_public_path__ + "static/media/messenger.70066568.svg";